import type { ReactNode } from "react";
import { AuthProvider } from "../context/AuthContext";
import { OrgProvider } from "../context/OrgContext";
import { SubscriptionProvider } from "../context/SubscriptionContext";
import { VerticalProvider } from "../context/VerticalContext";
import { LocalEngineProvider } from "../context/LocalEngineContext";

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <AuthProvider>
      <OrgProvider>
        <LocalEngineProvider>
          <VerticalProvider>
            <SubscriptionProvider>{children}</SubscriptionProvider>
          </VerticalProvider>
        </LocalEngineProvider>
      </OrgProvider>
    </AuthProvider>
  );
}
